module.exports = __webpack_public_path__ + "static/media/01_hero_tablet.a2ac9a9c.jpg";